import Component from '../core/Component'
import { disableScrolling, enableScrolling } from '../services/Viewport'

$(document).on('click', '.popup__bg, .popup__close', function (event) {
    event.preventDefault()
    enableScrolling()
    $(this).parents('.popup').removeClass('is-opened')
})

export default class PopupOpener extends Component {
    constructor($element) {
        super($element)

    }

    prepare() {
        var self = this
        this.$element.on('click', function (event) {
            event.preventDefault()
            disableScrolling()

            self.openPopup($(this).attr('href'))
            self.setValues($(this).attr('href'), $(this).data('setValues'))
        })
    }

    openPopup (id) {
        $(id).addClass('is-opened')

        //$(id).on('click', '.popup__bg', event => {
        //
        //})
    }

    setValues (id, values) {
        $(id).trigger('setValues', values)
    }
}


// WEBPACK FOOTER //
// ./components/PopupOpener.js